import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { formValueSelector } from 'redux-form';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { resetForm, submitForm } from 'State/forms/actions';
import { UpdateBidDetailsEnum, BidGroupEnum } from 'Common/FieldEnum';
import { UPDATE_BID_DETAILS_FORM_NAME } from 'Common/FormEnum';
import { Main, Filter } from 'Containers';
import {
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getVendorForCurrentSite,
  getAcctCategoryForCurrentSite,
} from 'State/filters/actions';
import { LoadingPage, DirtyWrapper } from 'Components';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { createToast, toastType, errorToast } from 'Common/ToastHelper';
import * as FilterSelector from 'State/filters/selectors';
import { ReportGeneration } from 'Common/ObjectHelper';
import {
  DATE_FORMAT_FOR_SERVER,
  DATE_FORMAT_FOR_UI,
  NOTIFICATION_DIALOG_MESSAGES,
  UNSAVED_MESSAGE,
} from 'Common/Constants';
import {
  setNotificationDialog,
  setYesNoDialogProps,
} from 'Components/dialogs/state/actions';
import { UpdateBidDetailsContainer } from './UpdateBidDetails';
import {
  getBidDetails,
  clearError,
  updateBidDetails,
  resetGrid,
} from './../../state/updateBidDetails/actions';
import { FILTER_VALUES } from '../../helper/updateBidDetails';
import * as Selectors from '../../state/updateBidDetails/selectors';

class BulkUpdateBidDetailsContainer extends Component {
  static propTypes = {
    resetForm: PropTypes.func.isRequired,
    submitForm: PropTypes.func.isRequired,
    getBidGroupForCurrentSite: PropTypes.func.isRequired,
    getItemGroupForCurrentSite: PropTypes.func.isRequired,
    getVendorForCurrentSite: PropTypes.func.isRequired,
    getAcctCategoryForCurrentSite: PropTypes.func.isRequired,
    getBidDetails: PropTypes.func.isRequired,
    clearError: PropTypes.func.isRequired,
    updateBidDetails: PropTypes.func.isRequired,
    resetGrid: PropTypes.func.isRequired,
    setNotificationDialog: PropTypes.func.isRequired,
    setYesNoDialogProps: PropTypes.func.isRequired,

    bidDetailsData: PropTypes.array.isRequired,
    submitted: PropTypes.bool.isRequired,
    isSubmittingBidPrice: PropTypes.bool.isRequired,
    loadingBidDetails: PropTypes.bool.isRequired,
    assignItemsBidGroupData: PropTypes.array.isRequired,
    assignItemsItemGroupData: PropTypes.array.isRequired,
    assignItemsVendorData: PropTypes.array.isRequired,
    acctCategoryData: PropTypes.array.isRequired,
    printData: PropTypes.string.isRequired,
    fetchingDropDown: PropTypes.bool.isRequired,
    BidPriceBeginDate: PropTypes.string,
    BidPriceEndDate: PropTypes.string,
    bidDetailsLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    submitError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    acctCategoryDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    vendorDataError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    bidGroupDataError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    itemGroupDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    bidDetailsInfo: PropTypes.array,
  };
  static defaultProps = {
    BidPriceBeginDate: '',
    BidPriceEndDate: '',
    bidDetailsLoadingError: null,
    submitError: null,
    acctCategoryDataError: null,
    vendorDataError: null,
    bidGroupDataError: null,
    itemGroupDataError: null,
    bidDetailsInfo: [],
  };
  static path = '/updatebiddetails';
  state = {
    filterValues: {
      ...FILTER_VALUES,
    },
    AsOfDate: new Date(),
    showUnsavedSiteDateModal: false,
    isAsOfDateChecked: false,
    showNoDataModal: false,
    showDateModal: false,
    activeIndexes: [0, 1],
    sorted: [],
    filtered: [],
  };
  handleVendorChange = (event, newValue, previousValue, name) => {
    if (newValue === previousValue) {
      return;
    }
    const filterValues = { ...this.state.filterValues };
    filterValues[name] = newValue;
    this.setState({ filterValues }, () => {
      const { getBidDetails } = this.props;
      const input = {
        ...this.state.filterValues,
        AsOfDate: null,
      };
      if (this.state.isAsOfDateChecked && this.state.AsOfDate) {
        input.AsOfDate = moment(this.state.AsOfDate).format(
          DATE_FORMAT_FOR_SERVER
        );
      }
      getBidDetails(input);
    });
  };
  handleChange = (e, values) => {
    if (_.isEqual(values, this.state.filterValues)) {
      return;
    }
    this.setState({ filterValues: values }, () => {
      const { getBidDetails } = this.props;
      const input = {
        ...this.state.filterValues,
        AsOfDate: null,
      };
      if (this.state.isAsOfDateChecked && this.state.AsOfDate) {
        input.AsOfDate = moment(this.state.AsOfDate).format(
          DATE_FORMAT_FOR_SERVER
        );
      }
      getBidDetails(input);
    });
  };

  handleUnsavedFilterDialog(result) {
    if (result) {
      this.clearFilters();
    }
  }
  clearFilters = () => {
    this.props.resetForm(UPDATE_BID_DETAILS_FORM_NAME);
    this.setState(
      {
        filtered: [],
        sorted: [],
        filterValues: {
          ...FILTER_VALUES,
        },
        isAsOfDateChecked: false,
        AsOfDate: new Date(),
      },
      () => {
        const { getBidDetails } = this.props;
        const input = {
          ...this.state.filterValues,
          AsOfDate: null,
        };
        getBidDetails(input);
      }
    );
  };
  handleClearFilters = () => {
    const { bidDetailsInfo } = this.props;
    if (bidDetailsInfo && bidDetailsInfo.length) {
      this.props.setYesNoDialogProps({
        showDialog: true,
        title: 'Un-saved changes detected',
        question: UNSAVED_MESSAGE,
        yesCallback: () => this.handleUnsavedFilterDialog(true),
        noCallback: () => this.handleUnsavedFilterDialog(false),
      });
    } else {
      this.clearFilters();
    }
  };
  handleAsOfDateCheckBoxChange = (e, { checked }) => {
    this.setState({ isAsOfDateChecked: checked }, () => {
      if (this.state.AsOfDate) {
        const { getBidDetails } = this.props;
        const input = {
          ...this.state.filterValues,
        };
        if (this.state.isAsOfDateChecked) {
          input.AsOfDate = this.state.isAsOfDateChecked
            ? moment(this.state.AsOfDate).format(DATE_FORMAT_FOR_SERVER)
            : null;
        }
        getBidDetails(input);
      }
    });
  };
  handleAsOfDateChange = (e, selectedDate, prevDate) => {
    if (selectedDate === prevDate) {
      return;
    }
    this.setState({ AsOfDate: selectedDate }, () => {
      if (this.state.isAsOfDateChecked && this.state.isAsOfDateChecked) {
        const { getBidDetails } = this.props;
        const input = {
          ...this.state.filterValues,
          AsOfDate: moment(this.state.AsOfDate).format(DATE_FORMAT_FOR_SERVER),
        };
        getBidDetails(input);
      }
    });
  };
  makeData = values => {
    const { bidDetailsInfo, setNotificationDialog } = this.props;
    let bidDetailsInfoCopy = _.cloneDeep(bidDetailsInfo);
    bidDetailsInfoCopy = bidDetailsInfoCopy.map(bidItem => {
      if (bidItem.checked) {
        delete bidItem.checked;
        return bidItem;
      }
      return undefined;
    });
    bidDetailsInfoCopy = _.compact(bidDetailsInfoCopy);
    if (!bidDetailsInfoCopy || !bidDetailsInfoCopy.length) {
      setNotificationDialog(
        NOTIFICATION_DIALOG_MESSAGES.BULK_UPDATE_BID_DETAIL_ITEM_UPDATE
      );
      return {};
    } else {
      return {
        BidPriceDetails: bidDetailsInfoCopy,
        [UpdateBidDetailsEnum.BidPriceBeginDate]: moment(
          values[UpdateBidDetailsEnum.BidPriceBeginDate]
        ).format(DATE_FORMAT_FOR_SERVER),
        [UpdateBidDetailsEnum.BidPriceEndDate]: moment(
          values[UpdateBidDetailsEnum.BidPriceEndDate]
        ).format(DATE_FORMAT_FOR_SERVER),
      };
    }
  };

  handleSaveSubmit = values => {
    if (
      moment(values[UpdateBidDetailsEnum.BidPriceBeginDate]).isAfter(
        values[UpdateBidDetailsEnum.BidPriceEndDate]
      )
    ) {
      this.props.setNotificationDialog(
        NOTIFICATION_DIALOG_MESSAGES.BULK_UPDATE_BID_DETAIL_DATE_VALIDATION
      );
    } else {
      const data = this.makeData(values);
      if (!_.isEmpty(data)) {
        this.props.scrollMainTo(0, 0);
        this.props.updateBidDetails(data, this.resetScroll);
        this.clearFilters();
      }
    }
  };
  // resetScroll = () => this.props.scrollMainTo(0, 0);
  onCancelClick = () => {
    this.props.resetGrid();
  };
  getMainProps = showDirtyConfirm => {
    const { bidDetailsInfo, isSubmittingBidPrice } = this.props;
    return {
      toolbox: {
        rightButtons: [
          {
            content: 'Cancel',
            onClick: showDirtyConfirm,
          },
          {
            content: 'Save',
            onClick: this.onSaveClick,
            disabled: !bidDetailsInfo || !bidDetailsInfo.length,
            loading: isSubmittingBidPrice,
          },
        ],
        shown: true,
      },
    };
  };
  componentDidMount() {
    const {
      getBidGroupForCurrentSite,
      getItemGroupForCurrentSite,
      getVendorForCurrentSite,
      getAcctCategoryForCurrentSite,
      getBidDetails,
    } = this.props;

    getBidGroupForCurrentSite(BidGroupEnum.AllOnly);
    getItemGroupForCurrentSite();
    getVendorForCurrentSite();
    getAcctCategoryForCurrentSite();
    const input = {
      ...this.state.filterValues,
      AsOfDate: null,
    };
    getBidDetails(input);
    this.props.scrollMainTo(0, 0);
  }
  componentDidUpdate(prevProps) {
    const { clearError, printData } = this.props;
    if (
      errorToast(this.props, prevProps, 'acctCategoryDataError') ||
      errorToast(this.props, prevProps, 'bidGroupDataError') ||
      errorToast(this.props, prevProps, 'itemGroupDataError') ||
      errorToast(this.props, prevProps, 'vendorDataError') ||
      errorToast(this.props, prevProps, 'bidDetailsLoadingError') ||
      errorToast(this.props, prevProps, 'submitError')
    ) {
      clearError();
    } else if (this.props.submitted && !prevProps.submitted) {
      createToast(
        toastType.success,
        'Success',
        'Bid details has been updated',
        true
      );
      clearError();
    }
    if (printData && printData !== prevProps.printData) {
      ReportGeneration(printData, 'Update Bid Details Report');
      clearError();
    }
  }
  componentWillUnmount() {
    toast.dismiss();
  }

  onSaveClick = () => {
    this.props.submitForm(UPDATE_BID_DETAILS_FORM_NAME);
  };
  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexes } = this.state;
    const activeIndexesClone = [...this.state.activeIndexes];
    activeIndexes.indexOf(index) !== -1
      ? activeIndexesClone.splice(activeIndexes.indexOf(index), 1)
      : activeIndexesClone.push(index);
    this.setState({ activeIndexes: activeIndexesClone });
  };
  onSortedChange = (sorted, column, shiftKey) => {
    this.setState({ sorted });
  };
  onFilteredChange = (filtered, column) => {
    this.setState({ filtered });
  };
  render() {
    const {
      bidDetailsData,
      assignItemsBidGroupData,
      assignItemsItemGroupData,
      assignItemsVendorData,
      acctCategoryData,
      loadingBidDetails,
      fetchingDropDown,
      isReadOnly,
      BidPriceBeginDate,
      BidPriceEndDate,
    } = this.props;
    const BidPriceBeginDateCopy = BidPriceBeginDate
      ? moment(BidPriceBeginDate).format(DATE_FORMAT_FOR_UI)
      : '';
    const BidPriceEndDateCopy = BidPriceEndDate
      ? moment(BidPriceEndDate).format(DATE_FORMAT_FOR_UI)
      : '';
    return (
      <Fragment>
        {fetchingDropDown && <LoadingPage />}
        <Fragment>
          <Filter
            title={'Update Item/Price Detail'}
            style={{
              width: 400,
            }}
          />
          <DirtyWrapper
            closeModalYesCallback={this.onCancelClick}
            isReadOnly={isReadOnly}
          >
            {showDirtyConfirm => (
              <Main
                {...this.getMainProps(showDirtyConfirm)}
                shouldNotUsePageWidth
              >
                <UpdateBidDetailsContainer
                  assignItemsBidGroupData={assignItemsBidGroupData}
                  assignItemsItemGroupData={assignItemsItemGroupData}
                  assignItemsVendorData={assignItemsVendorData}
                  bidDetailsData={bidDetailsData}
                  acctCategoryData={acctCategoryData}
                  loadingBidDetails={loadingBidDetails}
                  handleChange={this.handleChange}
                  filterValues={this.state.filterValues}
                  clearFilters={this.handleClearFilters}
                  handleAsOfDateChange={this.handleAsOfDateChange}
                  handleAsOfDateCheckBoxChange={
                    this.handleAsOfDateCheckBoxChange
                  }
                  isAsOfDateChecked={this.state.isAsOfDateChecked}
                  onSubmit={this.handleSaveSubmit}
                  initialValues={{
                    ...FILTER_VALUES,
                    [UpdateBidDetailsEnum.AsOfDate]: moment().format(
                      DATE_FORMAT_FOR_UI
                    ),
                    [UpdateBidDetailsEnum.BidPriceBeginDate]: BidPriceBeginDateCopy,
                    [UpdateBidDetailsEnum.BidPriceEndDate]: BidPriceEndDateCopy,
                    [UpdateBidDetailsEnum.BidDetailsInfo]: [],
                  }}
                  handleVendorChange={this.handleVendorChange}
                  activeIndexes={this.state.activeIndexes}
                  handleClick={this.handleClick}
                  onSortedChange={this.onSortedChange}
                  onFilteredChange={this.onFilteredChange}
                  sorted={this.state.sorted}
                  filtered={this.state.filtered}
                />
              </Main>
            )}
          </DirtyWrapper>
        </Fragment>
      </Fragment>
    );
  }
}

const selector = formValueSelector(UPDATE_BID_DETAILS_FORM_NAME);
const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(getIsDirty(UPDATE_BID_DETAILS_FORM_NAME)(state));

  return {
    bidDetailsData: Selectors.getBidPriceDetails(state),
    BidPriceBeginDate: Selectors.getBidPriceBeginDate(state),
    BidPriceEndDate: Selectors.getBidPriceEndDate(state),
    submitError: Selectors.getSubmitError(state),
    submitted: Selectors.getSubmitted(state),
    isSubmittingBidPrice: Selectors.getIsSubmittingBidPrice(state),
    bidDetailsLoadingError: Selectors.getBidDetailsLoadingError(state),
    loadingBidDetails: Selectors.getLoadingBidDetails(state),
    printData: Selectors.getPrintData(state),

    assignItemsBidGroupData: FilterSelector.getBidGroupData(state),
    assignItemsItemGroupData: FilterSelector.getItemGroupData(state),
    assignItemsVendorData: FilterSelector.getVendorData(state),
    acctCategoryData: FilterSelector.getAcctCategoryData(state),
    fetchingDropDown:
      FilterSelector.getBidGroupDataLoading(state) ||
      FilterSelector.getItemGroupDataLoading(state) ||
      FilterSelector.getVendorDataLoading(state) ||
      FilterSelector.getAcctCategoryDataLoading(state),
    acctCategoryDataError: FilterSelector.getAcctCategoryDataError(state),
    vendorDataError: FilterSelector.getVendorDataError(state),
    bidGroupDataError: FilterSelector.getBidGroupDataError(state),
    itemGroupDataError: FilterSelector.getItemGroupDataError(state),
    bidDetailsInfo: selector(state, [UpdateBidDetailsEnum.BidDetailsInfo]),
  };
};

const mapDispatchToProps = {
  resetForm,
  submitForm,
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getVendorForCurrentSite,
  getAcctCategoryForCurrentSite,
  getBidDetails,
  clearError,
  updateBidDetails,
  resetGrid,
  setNotificationDialog,
  setYesNoDialogProps,
};
export const BulkUpdateBidDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(BulkUpdateBidDetailsContainer);



// WEBPACK FOOTER //
// ./src/pages/utilities/updatebiddetails/containers/BulkUpdateBidDetails.js